function isEnabledValue(value: string | undefined): boolean {
  if (!value) return false;
  const v = value.trim().toLowerCase();
  return v === "1" || v === "true";
}

export function isUpgradeFlowEnabled(): boolean {
  return isEnabledValue(process.env.UPGRADE_FLOW_ENABLED);
}

type AccountIdentifiers = { userId?: string | null; email?: string | null };

function parseAllowlist(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

function matchesAllowlist(list: string[], identifiers: AccountIdentifiers): boolean {
  if (list.length === 0) return true;
  const candidates = [identifiers.userId, identifiers.email]
    .map((v) => (typeof v === "string" ? v.trim().toLowerCase() : ""))
    .filter(Boolean);
  return candidates.some((c) => list.includes(c));
}

export function isUpgradeFlowAllowedFor(identifiers: AccountIdentifiers): boolean {
  return matchesAllowlist(parseAllowlist(process.env.UPGRADE_FLOW_ALLOWLIST), identifiers);
}

export function canOpenUpgradeFlowClient(user: { id: string; email?: string | null } | null | undefined): boolean {
  return (
    isEnabledValue(process.env.NEXT_PUBLIC_UPGRADE_FLOW_ENABLED) &&
    matchesAllowlist(parseAllowlist(process.env.NEXT_PUBLIC_UPGRADE_FLOW_ALLOWLIST), {
      userId: user?.id,
      email: user?.email,
    })
  );
}
